import React, { Component } from 'react';
import PropTypes from 'prop-types';


import {
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import startCase from 'lodash/startCase';

class Pills extends Component {
  render(){
    return (
      <Nav pills style={{justifyContent:this.props.center ? 'center' : 'flex-start'}}>
        {this.props.states.map((state,index) => (
          <NavItem key={state}>
            <NavLink
              active={state === this.props.selected}
              onClick={this.props.onChange.bind(this,state)}
            >
              {this.props.titles[index] ? this.props.titles[index] : startCase(state)}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    )
  }
}

Pills.defaultProps = {
  titles:[]
}

Pills.propTypes = {
  onChange:PropTypes.func,
  selected:PropTypes.string,
  states:PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  titles:PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  center:PropTypes.bool
}

export default Pills;



// WEBPACK FOOTER //
// ./src/shared/components/Pills/index.js